import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { IconButton, Paper, Typography, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { getConf } from '@jbrowse/core/configuration';
import { getSession, getContainingView } from '@jbrowse/core/util';
import { getTrackName } from '@jbrowse/core/util/tracks';
import { SanitizedHTML } from '@jbrowse/core/ui';
import CascadingMenu from '@jbrowse/core/ui/CascadingMenu';
import { bindTrigger, bindPopover, usePopupState } from 'material-ui-popup-state/hooks';
// icons
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DragIcon from '@mui/icons-material/DragIndicator';
import CloseIcon from '@mui/icons-material/Close';
import MinimizeIcon from '@mui/icons-material/Minimize';
import AddIcon from '@mui/icons-material/Add';
var useStyles = makeStyles()(function (theme) {
  return {
    root: {
      background: alpha(theme.palette.background.paper, 0.8),
      '&:hover': {
        background: theme.palette.background.paper
      },
      transition: theme.transitions.create(['background'], {
        duration: theme.transitions.duration.shortest
      })
    },
    trackName: {
      margin: '0 auto',
      width: '90%',
      fontSize: '0.8rem',
      pointerEvents: 'none'
    },
    dragHandle: {
      cursor: 'grab'
    },
    dragHandleIcon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      pointerEvents: 'none'
    },
    iconButton: {
      padding: theme.spacing(1)
    }
  };
});
var TrackLabel = React.forwardRef(function (_ref, ref) {
  var track = _ref.track,
    className = _ref.className;
  var _a;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var view = getContainingView(track);
  var session = getSession(track);
  var trackConf = track.configuration;
  var minimized = track.minimized;
  var trackId = getConf(track, 'trackId');
  var trackName = getTrackName(trackConf, session);
  var popupState = usePopupState({
    popupId: 'trackLabelMenu',
    variant: 'popover'
  });
  var items = [{
    label: minimized ? 'Restore track' : 'Minimize track',
    icon: minimized ? AddIcon : MinimizeIcon,
    onClick: function onClick() {
      return track.setMinimized(!minimized);
    }
  }].concat(_toConsumableArray(((_a = session.getTrackActionMenuItems) === null || _a === void 0 ? void 0 : _a.call(session, trackConf)) || []), _toConsumableArray(track.trackMenuItems())).sort(function (a, b) {
    return (b.priority || 0) - (a.priority || 0);
  });
  return React.createElement(Paper, {
    ref: ref,
    className: cx(className, classes.root)
  }, React.createElement("span", {
    draggable: true,
    className: classes.dragHandle,
    onDragStart: function onDragStart(event) {
      var target = event.currentTarget;
      if (target.parentNode) {
        var parent = target.parentNode;
        event.dataTransfer.setDragImage(parent, 20, 20);
        view.setDraggingTrackId(track.id);
      }
    },
    onDragEnd: function onDragEnd() {
      return view.setDraggingTrackId(undefined);
    },
    "data-testid": "dragHandle-".concat(view.id, "-").concat(trackId)
  }, React.createElement(DragIcon, {
    className: classes.dragHandleIcon,
    fontSize: "small"
  })), React.createElement(IconButton, {
    onClick: function onClick() {
      return view.hideTrack(trackId);
    },
    className: classes.iconButton,
    title: "close this track"
  }, React.createElement(CloseIcon, {
    fontSize: "small"
  })), React.createElement(Typography, {
    variant: "body1",
    component: "span",
    className: classes.trackName
  }, React.createElement(SanitizedHTML, {
    html: trackName + (minimized ? ' (minimized)' : '')
  })), React.createElement(IconButton, _objectSpread({}, bindTrigger(popupState), {
    className: classes.iconButton,
    "data-testid": "track_menu_icon",
    disabled: !items.length
  }), React.createElement(MoreVertIcon, {
    fontSize: "small"
  })), React.createElement(CascadingMenu, _objectSpread({}, bindPopover(popupState), {
    onMenuItemClick: function onMenuItemClick(_, callback) {
      return callback();
    },
    menuItems: items,
    popupState: popupState
  })));
});
export default observer(TrackLabel);